function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import isNil from 'ramda/src/isNil';
import pathOr from 'ramda/src/pathOr';
import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { OrderAdditionalPropertyFieldsSelector } from 'invision-core/src/components/metadata/codes/codes.additional.properties.selectors';
import { additionalPropertiesMergeValuesIntoTemplate } from 'invision-core/src/components/metadata/codes/codes.helpers';
import { ALL_STEPS_KEYS, SERVICE_FEATURE_PRODUCT_STATUS_ACTIVE } from '../constants/products.wizard.constants';
import { OrderQuoteIsValidSelector, OrderQuotePaymentInstrumentsSelector, ShippingMethodsViewModel, SkipToCheckoutSelector } from './products.order.selectors';
import { ConvergentBillerAccountDetailsSelector } from './customer.convergent.biller.selectors';
import { RouteParams } from './customer.selectors';
var ProductsWizardStoreSelector = function ProductsWizardStoreSelector(state) {
  return state.customercare.recoverableUiState.productsWizard;
};
export var FeatureOrderProductPricingPlanQuantitySelector = createSelector([ConvergentBillerAccountDetailsSelector, RouteParams], function (accountDetails, routeParams) {
  var quantities = [];
  if (accountDetails && accountDetails.offerings) {
    accountDetails.offerings.forEach(function (offering) {
      var features = pathOr([], ['ServiceFeatures'], offering);
      features.forEach(function (feature) {
        if (feature.ServiceAttributeValues && feature.ServiceAttributeValues.length && feature.ServiceAttributeValues[0].Value === routeParams.serviceId) {
          var verifiedFeature = feature.ServiceAttributeValues.find(function (attribute) {
            return attribute.Value === routeParams.serviceId;
          });
          if (verifiedFeature && feature.Status === SERVICE_FEATURE_PRODUCT_STATUS_ACTIVE) {
            quantities.push({
              childItems: [],
              productId: feature.ProductId,
              productName: feature.ProductName,
              pricingPlanId: feature.PricingPlanId,
              subscriberProductId: feature.SubscriberProductId,
              shoppingCartItemBillerRuleDetails: feature.BillerRulePrices && feature.BillerRulePrices.length ? _toConsumableArray(feature.BillerRulePrices) : undefined
            });
          }
        }
      });
    });
  }
  return quantities;
});
export var IsShippingAddressSameAsBillingSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.isShippingAddressSameAsBilling;
});
export var CurrentStepIndexSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  if (wizardStore && !isNil(wizardStore.currentStepIndex)) {
    return wizardStore.currentStepIndex;
  }
  return -1;
});
export var PreviousStepIndexSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  if (wizardStore && !isNil(wizardStore.previousStepIndex)) {
    return wizardStore.previousStepIndex;
  }
  return -1;
});
export var CurrentStepSelector = createSelector([CurrentStepIndexSelector], function (currentStepIndex) {
  return ALL_STEPS_KEYS[currentStepIndex];
});
export var IsProductsStepSelector = createSelector([CurrentStepSelector], function (currentStep) {
  return currentStep === ALL_STEPS_KEYS[0];
});
export var IsCheckoutStepSelector = createSelector([CurrentStepSelector], function (currentStep) {
  return currentStep === ALL_STEPS_KEYS[1];
});
export var ShowPreviousButtonSelector = createSelector([IsProductsStepSelector, SkipToCheckoutSelector], function (isProductsStep, skipToCheckout) {
  return !isProductsStep && !skipToCheckout;
});
export var CompletedStepsSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.completedSteps;
});
export var SkippedStepSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.skippedSteps;
});
export var CurrentStepIsInvalidSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.currentStepIsInvalid;
});
export var SelectedTabIndexSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.selectedTabIndex;
});
var DEFAULT_TAB_PANEL_VIEW_MODEL = Immutable([{
  glyph: 'shopping-cart',
  notificationCount: 0
}, {
  glyph: 'user',
  notificationCount: 0
}
// {
//     glyph: 'file-text',
//     notificationCount: 0
// }
// Commenting out since we are going implement in the future
]);
export var TabPanelViewModelSelector = createSelector([SelectedTabIndexSelector], function (selectedTabIndex) {
  return DEFAULT_TAB_PANEL_VIEW_MODEL.map(function (item, index) {
    return item.set('active', index === selectedTabIndex);
  });
});
export var ChangeImmediateSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.changeImmediately;
});
export var PaymentInstrumentsSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.paymentInstruments;
});
export var PaymentInstrumentsCleanSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  var returnObject = wizardStore.paymentInstruments;
  if (returnObject && returnObject.length && returnObject[0]) {
    return returnObject[0].without(['Id', 'recordPayment', 'Locked']);
  }
  return returnObject;
});
export var PaymentInstrumentIdsSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.paymentInstrumentIds;
});
export var PaymentInstrumentIdsValidInQuoteSelector = createSelector([PaymentInstrumentIdsSelector, OrderQuotePaymentInstrumentsSelector], function (paymentInstrumentIds, orderQuotePaymentInstruments) {
  if (orderQuotePaymentInstruments && orderQuotePaymentInstruments.length) {
    var validPaymentInstrumentIds = [];
    paymentInstrumentIds.forEach(function (paymentInstrumentId) {
      var foundPayment = orderQuotePaymentInstruments.find(function (orderQuotePaymentInstrument) {
        return orderQuotePaymentInstrument.Id === paymentInstrumentId;
      });
      if (!foundPayment || foundPayment && foundPayment.Amount) {
        validPaymentInstrumentIds.push(paymentInstrumentId);
      }
    });
    return Immutable(validPaymentInstrumentIds);
  }
  return paymentInstrumentIds;
});
export var ProductOrderShippingAddressIdSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.shippingAddressId;
});
export var IsShippingMethodsAvailableSelector = createSelector([OrderQuoteIsValidSelector, ProductOrderShippingAddressIdSelector, ShippingMethodsViewModel], function (isQuoteValid, selectedShippingAddressId, shippingMethods) {
  return !!(isQuoteValid && selectedShippingAddressId && shippingMethods.length);
});
export var ProductOrderShippingMethodIdSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.shippingMethodId;
});
export var ProductWizardIsGiftOrderSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.isGiftOrder || false;
});
export var ProductWizardGiftOrderInfoSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.giftOrderInfo || {};
});
export var ProductWizardOrderDetailsSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.orderDetails;
});
export var IsProductWizardRestoreOrderWaivingFeeSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.waiveFee || false;
});
export var IsProductWizardRestoreOrderWaivingLateFeeSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.waiveLateFee || false;
});
export var ProductWizardRestoreOrderWaiveFeeReasonSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.waiveFeeReason || null;
});
export var ProductWizardRestoreOrderWaiveLateFeeReasonSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.waiveLateFeeReason || null;
});
export var ProductWizardTemporaryShipToNameSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.temporaryShipToName;
});
export var OttExecutionOptionsSelector = createSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return Immutable(wizardStore.executionOptions);
});
export var OrderAdditionalPropertiesSelector = createImmutableSelector([ProductsWizardStoreSelector], function (wizardStore) {
  return wizardStore.orderAdditionalProperties;
});
export var OrderAdditionalPropertyListMapSelector = createImmutableSelector([OrderAdditionalPropertiesSelector, OrderAdditionalPropertyFieldsSelector], function (additionalPropertyValues, additionalPropertyFields) {
  return additionalPropertiesMergeValuesIntoTemplate(additionalPropertyFields, additionalPropertyValues);
});